import React from "react";
import { Route } from "react-router-dom";
import appRoutes from "../../router/routes";

const Router = props => {
  let menu = null;

  if (props.isAuthenticated) {
    menu = appRoutes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={props => <route.component {...props} />}
        />
      ) : null;
    });

    return menu;
  }
};

export default Router;
